import Relationship from '.'
import Model from '../Model'
import QueryBuilder from '../QueryBuilder'
import { Builder } from '../Builder'

type OneOrMany = 'one' | 'many'

export class HasOneOrMany extends Relationship {

    protected _currentKey: string

    protected _foreignKey: string

    constructor(relativeBuilder: Builder & QueryBuilder, currentModel: Model, foreignKey: string, currentKey: string) {

		super(relativeBuilder, currentModel);

		this._currentKey = currentKey

		this._foreignKey = foreignKey

		this.addDefaultConstraints()
    }
    
    protected addDefaultConstraints(): void {

		if (Relationship.constraints) {
				
			this.getRelativeBuilder().where(this.getForeignkey(), this.getCurrentModel().getPrimaryKeyId())
		}
    }

    protected getForeignkey(): string {

        return this._foreignKey
    }

    protected getCurrentKey(): string {
        
        return this._currentKey
	}
	
	public addPersistentConstraints(currentModels: Model[]): void {

		this.getRelativeBuilder().whereIn(this.getForeignkey(), this.getModelsId(currentModels));
	}

	public match(currentModels: Model[], relativeModels: Model[], relativeName: string) {
		throw Error('match is not in hasOne or hasMany')
	}

	protected matchOneOrMany(currentModels: Model[], relativeModels: Model[], relativeName: string, type: OneOrMany): boolean {

		const groupRelativeResultByForeignKey = this.setForeignKeyAsResultIndex(relativeModels)
		
        currentModels.forEach((model: Model) => {

			const currentModelID = this.getModelId(model)

            // if(currentModelID in groupRelativeResultByForeignKey) {
				
                model.setRelative(relativeName, this.getRelationValue(groupRelativeResultByForeignKey[currentModelID] || [], type))
            // }
        })

        return true
	}

	protected setForeignKeyAsResultIndex(relativeModels: Model[]): Record<any, any> {
		
		const foreignKey: any = this.getForeignkey()

        const groupRelativeResultByForeignKey: any = relativeModels.reduce<Record<any, any>>((result, row) => {
			
			const currentModelID: any = row[foreignKey as keyof Model]

            if(currentModelID in result) {
                result[currentModelID].push(row)
            } else {
                result[currentModelID] = [row]
            }

            return result
		}, {})
		
		return groupRelativeResultByForeignKey
	}
	
	protected getRelationValue(value: Model[], type: OneOrMany): any {

		return type === 'one' ? value[0] || null : value;
	}

}

export default HasOneOrMany